import { jsx as _jsx } from "react/jsx-runtime";
import { TabList as ChakraTabList } from '@chakra-ui/react';
/**
 * TabList is used to manage a list of tab buttons.
 * It renders a div by default, and is responsible the keyboard interaction between tabs.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/tabs
 */
export function TabList({ alignItems = 'flex-end', children, ...props }) {
    return (_jsx(ChakraTabList, { alignItems: alignItems, ...props, children: children }));
}
//# sourceMappingURL=tabList.js.map